// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Box, Button, Modal, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
// Others
import { ConfirmModalType } from '~/utils/type/common';
// Styles, images, icons
import styles from './ConfirmModal.module.scss';

type Props = {
  icon?: string;
  title?: string;
  description?: string;
  textCancel?: string;
  textConfirm?: string;
  type?: ConfirmModalType;
  onClose: () => void;
  onConfirm?: () => void;
};

const cx = classNames.bind(styles);

const ConfirmModal = (props: Props) => {
  //#region Destructuring Props
  const { icon, title, description, textCancel, textConfirm, type = 'default', onClose, onConfirm } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Modal open={true}>
      <Box id='confirmModalComponent' className={cx('container')}>
        <Stack direction={'column'} alignItems={'center'} gap={'10px'}>
          {icon && <img src={icon} alt={t('common_img_text_alt')} className={cx('iconConfirm')} />}
          <Typography className={cx('title')} justifyItems={'center'} alignItems={'center'}>
            {title}
          </Typography>
          <Typography className={cx('description')}>{description}</Typography>
        </Stack>

        <Stack direction={'row'} justifyContent={'space-between'} marginTop={'30px'} gap={'12px'}>
          <Button variant={'outlined'} type='button' className={cx('button', 'buttonCancel')} onClick={onClose}>
            {textCancel || t('common_action_cancel')}
          </Button>

          <Button
            variant={'contained'}
            color={type === 'delete' ? 'error' : 'primary'}
            className={cx('button')}
            type='button'
            onClick={onConfirm}
          >
            {textConfirm || t('common_action_ok')}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ConfirmModal;
